import { RichText } from 'prismic-dom'

export const richText = content => content ? RichText.asHtml(content) : null;
export const plainText = (text = '')  => text.length ? RichText.asText(text) : null;

export const link = (link, text) => {
  if (!text && !(link.url || link.slug)) return null;

  const linkText = plainText(text);

  if (link.link_type === 'Document') {
    return { url: link.slug, isExternal: false, text: linkText };
  } else {
    return { url: link.url, isExternal: true, text: linkText };
  }
};

export const yesNo = (answer = '') => answer ? answer.toLowerCase() === 'yes' : null;

export const footerPages = (items = []) => items.map(page => ({
  cta: page.link && page.text ? link(page.link, page.text) : null,
}));

export const footerSocial = (items = []) => items.map(social => ({
  icon: social.icon ? social.icon.toLowerCase() : null,
  link: social.link_url ? plainText(social.link_url) : null,
  text: social.text ? plainText(social.text) : null,
}));

export const documents = (items) => {
  if (!items || !(items instanceof Array))
    return [];

  return items.map(item => {
    const document = link(item.document_link, item.document_title);
    return {
      url: document.url,
      text: document.text,
    };
  });
};


export default {
  richText,
  link,
  plainText,
  yesNo,
  footerPages,
  footerSocial,
  documents,
};



// WEBPACK FOOTER //
// ./src/utils/prismicHelpers.js